import { pageLocale } from "../../../utils/locale";

//Tug SIDE & FRONT, Gait And Balance This is common style file for gauge constants
const {
  speed,
  step_length,
  steps_per_minute,
  shoulder_balance,
  head_wobbling,
  hip_balance,
  sit_to_standup_time,
  attempts_to_rise,
  good,
  average,
  poor,
  s,
  steps_min,
} = pageLocale("newreport");
export const StraightLineModels = {
  fronttugTime: {
    range: [
      { cond: "X < 12", type: good },
      { cond: "12 <= X && X <= 14", type: average },
      { cond: "X > 14", type: poor },
    ],
  },
  frontgaitSummary: {
    range: [
      { cond: "X < 2", type: poor },
      { cond: "2 <= X && X <= 4", type: average },
      { cond: "4 < X", type: good },
    ],
  },
  frontBalancesummary: {
    range: [
      { cond: "X < 2", type: poor },
      { cond: "2 <= X && X < 4", type: average },
      { cond: "4 <= X", type: good },
    ],
  },
  frontgaitSpeed: {
    title: speed,
    range: [
      { cond: "X < 40", minMax: [0, 40], type: poor },
      { cond: "40 <= X && X < 50", minMax: [40, 50], type: average },
      { cond: "50 <= X", minMax: [50, 200], type: good },
    ],
    unit: "cm/s",
    bgType: 0,
  },
  frontgaitStepLength: {
    title: step_length,
    range: [
      { cond: "50 <= X", minMax: [50, 200], type: good },
      { cond: "40 <= X && X < 50", minMax: [40, 50], type: average },
      { cond: "X < 40", minMax: [0, 40], type: poor },
    ],
    unit: "cm",
    bgType: 0,
  },
  frontgaitStepPerMinute: {
    title: steps_per_minute,
    range: [
      { cond: "X >= 50", minMax: [50, 100], type: good },
      { cond: "40 < X && X < 50", minMax: [40, 50], type: average },
      { cond: "40 >= X", minMax: [0, 40], type: poor },
    ],
    unit: steps_min,
    bgType: 0,
  },
  sideBalancesummary: {
    range: [
      { cond: "X < 2", type: poor },
      { cond: "2 <= X && X < 4", type: average },
      { cond: "4 <= X", type: good },
    ],
  },
  frontShoulderBalance: {
    title: shoulder_balance,
    range: [
      { cond: "X <= 2", minMax: [0, 2], type: good },
      { cond: "2 < X && X <= 5", minMax: [2, 5], type: average },
      { cond: "5 < X", minMax: [5, 10], type: poor },
    ],
    unit: "",
    bgType: 0,
  },
  frontHipBalance: {
    title: hip_balance,
    range: [
      { cond: "X <= 2", minMax: [0, 2], type: good },
      { cond: "2 < X && X <= 5", minMax: [2, 5], type: average },
      { cond: "5 < X", minMax: [5, 10], type: poor },
    ],
    unit: "",
    bgType: 0,
  },
  frontbalanceHeadWobbling: {
    title: head_wobbling,
    range: [
      { cond: "X <= 1.5", minMax: [0, 1.5], type: good },
      { cond: "1.5 <= X", minMax: [1.5, 3], type: poor },
    ],
    unit: "(cm)",
    bgType: 0,
  },
  sittingBalance: {
    title: sit_to_standup_time,
    range: [
      { cond: "X == 1", minMax: [1, 1], type: good },
      { cond: "X == 0", minMax: [0, 0], type: poor },
    ],
    unit: s,
    bgType: 0,
  },
  attemptsToRise: {
    title: attempts_to_rise,
    range: [
      { cond: "X == 0", minMax: [0, 1], type: good },
      { cond: "X == 1", minMax: [1, 2], type: average },
      { cond: "X >= 2", minMax: [2, 10], type: poor },
    ],
    unit: "count",
    bgType: 0,
  },
};
